import { DashboardSettingKeys, InteractivityProfile, VisualSettingKeys, } from 'logi-embed/types';
var InvetoryTypes;
(function (InvetoryTypes) {
    InvetoryTypes["Dashboard"] = "dashboard";
    InvetoryTypes["Visual"] = "visual";
    InvetoryTypes["Source"] = "source";
})(InvetoryTypes || (InvetoryTypes = {}));
export { InteractivityProfile };
export { DashboardSettingKeys };
export { VisualSettingKeys };
